<template>
  <v-toolbar-items>
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          :disabled="isLoading"
          text
        >
          <v-icon color="gray-6">today</v-icon>
          <span class="ml-1">{{ $t(`${namespace}.${selectedPeriod}`) }}</span>
          <v-icon
            :color="selectedPeriod === 'currentMonth' ? 'gray-6' : 'primary'"
            right
            small
            @click="selectedPeriod !== 'currentMonth' ? resetPeriod() : null"
          >
            {{ selectedPeriod === 'currentMonth' ? 'keyboard_arrow_down' : 'close' }}
          </v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
           v-for="period in periods" :key="period"
          @click="getPeriod(period)"
        >
          <v-list-item-title>
            <span class="menu__item__text">{{ $t(`${namespace}.${period}`) }}</span>
          </v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item @click="getPeriod('custom')">
          <v-list-item-title>
            <span class="menu__item__text">{{ $t(`${namespace}.custom`) }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <Dialog
      :visible="dialog"
      @applyPeriod="applyCustomPeriod"
      @close="closeDialog"
    />
  </v-toolbar-items>
</template>

<script>
import moment from 'libs/moment'
import Dialog from './Dialog'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'MenuItemPeriod',
  props: {
    status: {
      type: Number,
      default: STATUS_SUCCESS
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Dialog
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Components.MenuItemPeriod',
      selectedPeriod: 'currentMonth',
      dialog: false,
      YYYY_MM_DD: 'YYYY-MM-DD',
      YYYY_MM_: 'YYYY-MM-',
      startDate: null,
      endDate: null,
      periods: [
        'currentMonth',
        'lastWeek',
        'lastMonth',
        'lastThreeMonths',
        'today'
      ]
    }
  },
  methods: {
    getPeriod (period) {
      this.visibility = false

      if (period === 'custom' || this.selectedPeriod !== period) {
        switch (period) {
          case 'currentMonth':
            this.setPeriod('currentMonth')
            this.currentMonth()
            break

          case 'lastWeek':
            this.setPeriod('lastWeek')
            this.lastWeek()
            break

          case 'lastMonth':
            this.setPeriod('lastMonth')
            this.lastMonth()
            break

          case 'lastThreeMonths':
            this.setPeriod('lastThreeMonths')
            this.lastThreeMonths()
            break

          case 'today':
            this.setPeriod('today')
            this.today()
            break

          case 'custom':
            this.custom()
            break
        }
      }
    },

    setPeriod (period) {
      this.selectedPeriod = period
      this.$emit('changePeriod', period)
    },

    currentMonth () {
      const today = new Date()
      const day = String(today.getDate()).padStart(2, '0')
      const daysInMonth = moment().daysInMonth()
      const days = Number(day) < daysInMonth ? day : daysInMonth
      this.startDate = moment().format(this.YYYY_MM_) + '01'
      this.endDate = moment().format(this.YYYY_MM_) + days
      this.emitPeriod()
    },

    lastWeek () {
      this.startDate = moment()
        .subtract(1, 'weeks')
        .startOf('isoWeek')
        .subtract(1, 'days')
        .format(this.YYYY_MM_DD)

      this.endDate = moment()
        .subtract(1, 'weeks')
        .endOf('isoWeek')
        .subtract(1, 'days')
        .format(this.YYYY_MM_DD)

      this.emitPeriod()
    },

    lastMonth () {
      const subtractOneMonth = moment().subtract(1, 'months')
      this.startDate = subtractOneMonth.format(this.YYYY_MM_) + '01'
      this.endDate = subtractOneMonth.format(this.YYYY_MM_) + subtractOneMonth.daysInMonth()
      this.emitPeriod()
    },

    lastThreeMonths () {
      const subtractThreeMonth = moment().subtract(3, 'months')
      const subtractOneMonth = moment().subtract(1, 'months')
      this.startDate = subtractThreeMonth.format(this.YYYY_MM_) + '01'
      this.endDate = subtractOneMonth.format(this.YYYY_MM_) + subtractOneMonth.daysInMonth()
      this.emitPeriod()
    },

    today () {
      const endTime = moment().format('HH:mm')
      this.startDate = `${moment().format(this.YYYY_MM_DD)}T00:00`
      this.endDate = `${moment().format(this.YYYY_MM_DD)}T${endTime}`
      this.emitPeriod()
    },

    custom () {
      this.openDialog()
    },

    emitPeriod () {
      this.$emit('change', {
        startDate: this.startDate,
        endDate: this.endDate
      })
    },

    openDialog () {
      this.dialog = true
    },

    closeDialog (period) {
      this.setPeriod(period)
      this.dialog = false
    },

    resetPeriod () {
      this.startDate = null
      this.endDate = null
      this.setPeriod('currentMonth')
      this.emitPeriod()
    },

    applyCustomPeriod ({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.emitPeriod()
    }
  },
  mounted () {
    this.currentMonth()
  }
}
</script>
